export default {
	reference: {
		resettable: true,
		emptyText: "ra.users.all_users",
	},
};
